// extracted by mini-css-extract-plugin
export var container = "_t1-0";
export var table = "_t1-2";
export var tableWrapper = "_t1-1";